export function showEmployeeQuestion(state: string | undefined): boolean {
  return state !== 'WA'
}

export function showAdditionalRelationshipQuestion(
  state: string | undefined
): boolean {
  return state !== 'WA'
}
